import { IMAGE_TYPES } from "./constants";

const getDocLabel = (imageType) =>
  IMAGE_TYPES.find((t) => t.id === imageType)?.label ?? "เอกสารอื่น ๆ";

const getFileType = (path = "") => {
  const ext = path.toLowerCase().split(".").pop();
  if (ext === "pdf") return "pdf";
  if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
  return "other";
};

export { getDocLabel, getFileType };
